import { useContext } from 'react';
import { ActivesContext } from '../context/ActiveContext';


export function useActives() {
  const context = useContext(ActivesContext);

  return context;
}
